import React, { useState, useCallback, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { TradeState } from '../../../_shared/types/trade';
import { FilterContext } from '../internal';
import { FilterType } from '../../../_shared/constants/filters';

import { StyledTradeFilter, StyledTrade, Label, StyledToggle } from './Styles';

const propTypes = {
  tradeState: PropTypes.number.isRequired
};

const TradeFilter = ({ tradeState }) => {
  const {
    filterMetaData: { tradeConditions },
    updateFilter
  } = useContext(FilterContext);
  const [tradeFilters, setTradeFilters] = useState(() => {
    const labelConditions = [
      {
        label: <FormattedMessage id="list.filters.inStock" />,
        name: 'isInStock',
        value: tradeConditions.isInStock
      },
      {
        label: <FormattedMessage id="list.filters.franchiseDealers" />,
        name: 'isFranchiseDealer',
        value: tradeConditions.isFranchiseDealer
      }
    ];

    if (tradeState !== TradeState.upcoming) {
      labelConditions.splice(1, 0, {
        label: <FormattedMessage id="list.filters.floorMet" />,
        name: 'isFloorPriceMet',
        value: tradeConditions.isFloorPriceMet
      });
    }

    return labelConditions;
  });

  useEffect(() => {
    setTradeFilters(prevState => {
      let updatedTradeFilter;
      if (prevState.length === 2 && tradeState === TradeState.active) {
        updatedTradeFilter = [
          {
            ...prevState[0],
            value: tradeConditions.isInStock
          },
          {
            label: <FormattedMessage id="list.filters.floorMet" />,
            name: 'isFloorPriceMet',
            value: tradeConditions.isFloorPriceMet
          },
          {
            ...prevState[1],
            value: tradeConditions.isFranchiseDealer
          }
        ];
      } else if (prevState.length === 3 && tradeState === TradeState.upcoming) {
        updatedTradeFilter = [
          {
            ...prevState[0],
            value: tradeConditions.isInStock
          },
          {
            ...prevState[2],
            value: tradeConditions.isFranchiseDealer
          }
        ];
      } else {
        updatedTradeFilter = prevState.map(item => {
          return { ...item, value: tradeConditions[item.name] };
        });
      }
      return updatedTradeFilter;
    });
  }, [tradeConditions, tradeState]);

  // TODO refactor tradeConditions model to match array representation used in state
  const handleToggle = useCallback(
    filterName => {
      const updatedTradeCondition = {};
      const updatedTradeFilter = tradeFilters.map(filter => {
        const update = { ...filter };
        if (filter.name === filterName) {
          update.value = !filter.value;
        }
        updatedTradeCondition[filter.name] = update.value;
        return update;
      });

      setTradeFilters(updatedTradeFilter);

      updateFilter(updatedTradeCondition, FilterType.TradeCondition);
    },
    [tradeFilters, updateFilter]
  );

  return (
    <StyledTradeFilter>
      {tradeFilters.map(filter => {
        return (
          <StyledTrade key={filter.name}>
            <Label>{filter.label}</Label>
            <StyledToggle
              testId={`filter-${filter.name}Only`}
              onClick={() => handleToggle(filter.name)}
              className="filter-toggle"
              isChecked={filter.value}
            />
          </StyledTrade>
        );
      })}
    </StyledTradeFilter>
  );
};

TradeFilter.propTypes = propTypes;

export default TradeFilter;
